import { useState, useEffect, useCallback } from 'react'
import * as actions from '@actions'
import { useOutletContext } from 'react-router-dom'

const useTemplateFieldsListViewModel = template => {
    
    const [templateFields, setTemplateFields] = useState([])
    const [availableFields, setAvailableFields] = useState([])
    
    const { organization } = useOutletContext()
    
    const fetchavailableFields = useCallback(async () => {
        
        try {
            
            const res = await actions.getAllExportTemplateFields(organization.id, template.id)
            
            setAvailableFields(res)
            
        } catch (e) {
            
            // @todo show error
            console.error('fetchavailableFields', e)
            
        }
        
    }, [organization, template])
    
    useEffect(() => {
        
        if (organization?.id && template?.id)
            fetchavailableFields()
        
    }, [organization, template])
    
    useEffect(() => {
        
        if (template?.id)
            setTemplateFields(JSON.parse(JSON.stringify(template.fields)))
        
    }, [template])
    
    return {
        templateFields,
        setTemplateFields,
        availableFields,
        setAvailableFields,
    }
    
}

export default useTemplateFieldsListViewModel
